import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/cat.png'


const _hoisted_1 = { class: "home" }

import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_0
    }, null, -1)),
    _createVNode(HelloWorld, { msg: "前端vue3+ts开发框架" }),
    _cache[1] || (_cache[1] = _createElementVNode("h1", null, "目录结构", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      alt: "tree",
      src: _imports_1
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("h1", null, "拥抱script setup", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("pre", { class: "pre" }, _toDisplayString(`<script setup lang='ts'>
  import componentA from './componentA.vue'
  // 变量
  const msg = 'Hello!'

  // 函数
  function log() {
    console.log(msg)
  }
</script>

<template>
  <componentA />
  <div @click="log">\{\{ msg \}\}</div>
</template>
`), -1))
  ]))
}
}

})